import {
  defineComponent,
  reactive,
  computed,
  ref,
  onMounted,
  onUnmounted,
} from "@vue/composition-api";

export default () => {
  const el = ref(null);
  let sticky = ref(false);
  let stickyClass = computed(() => (sticky.value ? "sticky" : null));

  let stickyHandler = () => {
    if (el) {
      let element = el.value;
      sticky.value = window.pageYOffset > element.offsetTop;
    }
  };

  onMounted(() => {
    window.addEventListener("scroll", stickyHandler);
  });

  onUnmounted(() => {
    window.removeEventListener("scroll", stickyHandler);
  });

  return { el, sticky, stickyClass };
};
